<div class="row">
  <!-- Titre et sous-titre -->
  <div class="cell-lg-8 cell-md-10 cell-sm-12 offset-lg-2 offset-md-1">
    <div class="card mt-4">
      <div class="card-header text-center">
        <h4 class="text-bold">{{ 'Your Sites' | translate }}</h4>
        <p>{{ 'Choose your work site' | translate }}...</p>
      </div>
    </div>
  </div>

  <!-- Liste des sites et boutons -->
  <div class="cell-lg-8 cell-md-10 cell-sm-12 offset-lg-2 offset-md-1">
    <div class="card mt-4">
      <div class="card-content">
        <ul class="items-list" *ngIf="currentSites?.length > 0">
          <li class="item" *ngFor="let cs of currentSites"
              [ngClass]="{'bg-cyan' : (currentSite && currentSite.id == cs.id)}">
            <div class="row" (click)="selectSite(cs)" (dblclick)="onChoice(cs)">
              <div class="cell-12">
                <span class="mif-location-city fg-amber avatar mr-2"></span>
                <span class="label">
                  {{ cs.name }} ({{ 'Site de type' | translate }} :
                  {{ cs.type | titlecase }} {{ 'et situé à' | translate }}
                  {{ cs.localisation }})
                </span>
              </div>
            </div>
          </li>
        </ul>
          <!-- Ligne des boutons -->
          <!-- Ligne des boutons avec plus d'espace -->
          <div style="border-top: 1px #dfdfdf solid;">
            <div class="row mt-5 flex-wrap" style="min-height: 150px;">
              <div class="cell-md-6 cell-sm-12 mb-2">
                <button m4-button
                        class="w-100"
                        (click)="onAbandonner()"
                        [rounded]="true"
                        btn-style="alert">
                  {{ 'Leave' | translate }}
                  <m4-icon icon="arrow-right"></m4-icon>
                </button>
              </div>

              <div class="cell-md-6 cell-sm-12 mb-2">
                <button m4-button
                        class="w-100"
                        (click)="onCancel()"
                        [rounded]="true"
                        btn-style="warning">
                  {{ 'Cancel' | translate }}
                  <m4-icon icon="arrow-right"></m4-icon>
                </button>
              </div>

              <div class="cell-md-6 cell-sm-12 mb-2">
                <button m4-button
                        class="w-100"
                        [disabled]="!currentSite"
                        (click)="onChoice(currentSite)"
                        [rounded]="true"
                        btn-style="success">
                  {{ 'Choice' | translate }}
                  <m4-icon icon="arrow-right"></m4-icon>
                </button>
              </div>

              <div class="cell-md-6 cell-sm-12 mb-2">
                <button m4-button
                        class="w-100"
                        [disabled]="currentSite"
                        (click)="onWorkToCentral()"
                        [rounded]="true"
                        btn-style="info">
                  {{ 'Work at the central' | translate }}
                  <m4-icon icon="arrow-right"></m4-icon>
                </button>
              </div>
            </div>
          </div>


      </div>
    </div>
  </div>
</div>
